<template>
  <v-container>
    <v-layout justify-start class="links">
      <router-link to="/">groma AprilTag</router-link>
      <v-spacer></v-spacer>
      <v-btn class="primary primary--text" flat small round outline onclick="window.print();">印刷</v-btn>
    </v-layout>
    <!-- 上部のフォーム -->
    <v-form class="mb-5 apriltag-form">
      <!-- #### タグファミリー選択部分 ### -->
      <v-layout justify-center>
        <v-menu offset-y class="mb-2">
          <v-btn slot="activator" flat style="text-transform:none;">
            <h2>{{tagFamily}}</h2>
            <v-icon>expand_more</v-icon>
          </v-btn>
          <div class="white pt-2">マーカーの種類</div>
          <v-list three-line>
            <v-list-tile @click="tagFamily='Tag36h11'">
              <v-list-tile-content>
                <v-list-tile-title>Tag36h11</v-list-tile-title>
                <v-list-tile-sub-title>公式に推奨されています。
                  <br>586番までのIDが検知ができます。
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile @click="tagFamily='Tag36h10'">
              <v-list-tile-content>
                <v-list-tile-title>Tag36h10</v-list-tile-title>
                <v-list-tile-sub-title>2319番のIDまで検知ができます。</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-layout>

      <v-layout justify-center>
        <span class="caption grey--text text--darken-1">プリントしたいマーカーの幅とIDを設定してください。
          <br class="hidden-sm-and-up">
          {{tagFamily}}&nbsp;は0から{{maxId}}まで検知ができます。
        </span>
      </v-layout>

      <!-- #### 表示形式フォーム　リロード部分 ### -->
      <v-layout row wrap justify-center align-center>
        <div class="pa-2">幅 (mm)
          <br>
          <input v-model="form.tagBlackWidth" v-on:keyup.enter="imgReload">
        </div>
        <div class="pa-2">開始ID
          <br>
          <input v-model="form.from" v-on:keyup.enter="imgReload">
        </div>
        <div class="pa-2">終了ID
          <br>
          <input v-model="form.to" v-on:keyup.enter="imgReload">
        </div>
        <div>
          <v-btn @click="imgReload" class="mt-4" small>更新</v-btn>
        </div>
        <div>
          <v-menu open-on-hover offset-y :nudge-width="250">
            <v-btn flat icon slot="activator" class="mt-4">
              <v-icon class="grey--text text--lighten-1">error_outline</v-icon>
            </v-btn>
            <v-card width="300" class="pa-2 caption">
              <v-layout text-xs-left align-center row>
                <v-flex>
                  <img width="100" src="/img/AprilTag/Download/howto.png">
                </v-flex>
                <v-flex>
                  <ul>
                    <li>マーカーの黒色の部分の横幅をご記入ください。</li>
                    <li>マーカーは白色の枠を残してお貼りください。</li>
                    <li>パソコンとプリンタの設定により印刷時は指定した幅とずれる場合がございますので、テスト印刷をしてご調整ください。</li>
                  </ul>
                </v-flex>
              </v-layout>
            </v-card>
          </v-menu>
        </div>
      </v-layout>

      <v-layout justify-center>
        <span class="caption red--text">{{error}}</span>
      </v-layout>

      <!-- #### 表示形式フォーム　オートスケール部分 ### -->
      <v-layout row justify-center class="mt-3">
        <div class="pa-2">ID表示
          <br>
          <v-switch v-model="showNum" style="flex:none;" class="ma-0" hide-details></v-switch>
        </div>

        <div class="pa-2">自動調整
          <br>
          <v-checkbox v-model="a4AutoFit" style="flex:none;" class="mt-0 mb-0 ml-3" hide-details></v-checkbox>
        </div>
        <div :class="a4AutoFit?'grey lighten-3 grey--text':''" class="pa-2">列数
          <br>
          <input v-model="column" :disabled="a4AutoFit">
        </div>
        <div :class="a4AutoFit?'grey lighten-3 grey--text':''" class="pa-2">行数
          <br>
          <input v-model="row" :disabled="a4AutoFit">
        </div>
      </v-layout>
    </v-form>

    <!-- 下部のタグリスト -->
    <v-layout align-center justify-center>
      <article>
        <section v-for="page in pages" class="print_pages mb-5" :key="page">
          <div>
            <h1>{{tagFamily}} ({{idRangeOnPage(page)}})</h1>
            <table>
              <tbody>
                <tr v-for="i in Number(row)" :key="i">
                  <td v-for="j in Number(column)" v-if="count(page,i,j)<=id.to" :key="j">
                    <div v-if="count(page,i,j)<=id.to">
                      <img
                        :src="filename(count(page,i,j))"
                        :style="'width:'+ tagWidthWithWhite+'mm'"
                        class="tag-img"
                      >
                      <div v-show="showNum">{{count(page,i,j)}}</div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      </article>
    </v-layout>
  </v-container>
</template>

<script>
let MAXID_36h11 = 586;
let MAXID_36h10 = 2319;
let A4PAGE_WIDTH = 200; //210mm
let A4PAGE_HEIGHT = 260; //297mm レターサイズを考慮

export default {
  name: "AprilTagList",
  metaInfo: {
    title: "groma | Tag download"
  },
  components: {
    //customerform: CustomerForm
  },
  data() {
    return {
      id: {
        from: 0,
        to: 99
      },
      form: {
        tagBlackWidth: 0,
        from: 0,
        to: 99
      },
      tagFamily: "Tag36h10",
      tagBlackWidth: 15,
      TAGWIDHT_PARAM: 0.8,
      row: 10,
      column: 10,
      showNum: true,
      maxId: MAXID_36h10,
      a4AutoFit: true,
      error: ""
    };
  },
  computed: {
    pages() {
      if (this.column <= 0 || this.row <= 0) return;
      return Math.ceil(
        (this.id.to - this.id.from + 1) / Number(this.row) / Number(this.column)
      );
    },
    // 白枠込みのタグの大きさ、印刷・表示用
    tagWidthWithWhite() {
      return this.tagBlackWidth / this.TAGWIDHT_PARAM;
    }
  },
  watch: {
    showNum() {
      this.imgReload();
    },
    tagFamily() {
      if (this.tagFamily == "Tag36h11") this.maxId = MAXID_36h11;
      else this.maxId = MAXID_36h10;
    }
  },
  methods: {
    count(page, i, j) {
      return (
        this.id.from +
        (this.column * this.row * (page - 1) + this.column * (i - 1) + (j - 1))
      );
    },

    filename(count) {
      let formatNum = ("00000" + count).slice(-5);
      if (this.tagFamily == "Tag36h11") {
        return require("@/tag/36h11/tag36_11_" + formatNum + "_100x100.png");
      } else {
        return require("@/tag/36h10/tag36_10_" + formatNum + "_100x100.png");
      }
    },

    imgReload() {
      // 幅のバリデート
      this.tagBlackWidth = parseInt(this.form.tagBlackWidth);
      if (isNaN(this.tagBlackWidth) || this.tagBlackWidth <= 0) {
        this.showError("1以上の数字をご記入ください。");
        return;
      }

      // A4 自動調整がオンのときは縦横計算して行・列を算出する
      if (this.a4AutoFit) {
        this.column = parseInt(A4PAGE_WIDTH / this.tagWidthWithWhite, 10);
        console.log(this.column);
        if (this.column <= 0) {
          this.error = "幅を小さくしてください。";
          return;
        }
        this.row = this.showNum
          ? parseInt(A4PAGE_HEIGHT / (this.tagWidthWithWhite + 6))
          : parseInt(A4PAGE_HEIGHT / (this.tagWidthWithWhite + 2));
      }

      // IDの表示領域をバリデートする
      let from = Number(this.form.from);
      let to = Number(this.form.to);

      if (from >= 0 && from <= this.maxId) {
        this.id.from = from;
      } else {
        this.id.from = 0;
        this.form.from = 0;
        this.showError(this.tagFamily + "は0から" + this.maxId + "までです。");
        return;
      }

      if (to >= 0 && to <= this.maxId) {
        this.id.to = to;
      } else {
        this.id.to = this.maxId;
        this.form.to = this.maxId;
        this.showError(this.tagFamily + "は0から" + this.maxId + "までです。");
        return;
      }

      // fromとtoの比較
      if (to <= from) {
        this.id.to = this.id.from;
        this.form.to = this.form.from;
      }

      this.clearError();
    },
    idRangeOnPage(page) {
      var fromIdOnPage = this.id.from + (page - 1) * this.column * this.row;
      var toIdOnPage = this.id.from + page * this.column * this.row - 1;
      if (toIdOnPage > this.id.to) toIdOnPage = this.id.to;

      return fromIdOnPage + " ~ " + toIdOnPage;
    },
    showError(error) {
      this.error = error;
    },
    clearError() {
      this.error = "";
    }
  },

  created() {
    this.form.tagBlackWidth = this.tagBlackWidth;
    this.form.from = this.id.from;
    this.form.to = this.id.to;
  },
  mounted() {
    // this.imgReload();
  }
};
</script>

<style scoped>
input {
  width: 60px;
  padding: 2px;
  padding-left: 10px;
  border: solid 1px #aaa;
}
.v-btn--top:not(.v-btn--absolute) {
  top: 50px;
}
.v-btn--right:not(.v-btn--absolute) {
  right: 30px;
}
@media print {
  .apriltag-form {
    display: none;
  }
}
</style>

<!-- プリント時のCSS -->
<style type="text/css" media="print" >
.print_pages {
  page-break-after: always;
}
/*最後のページは改ページを入れない*/
.print_pages:last-child {
  page-break-after: auto;
}
.form-table,
.form-table td {
  border: 0px;
}
table {
  border-collapse: collapse;
  border-spacing: 0px;
}
td {
  border: 1px solid #aaa;
}

@page {
  margin: 5mm;
}

@media print {
  body {
    width: 210mm; /* needed for Chrome */
  }
  .apriltag-form {
    display: none;
  }
  .links {
    display: none !important;
  }
  #wovn-translate-widget {
    display: none !important;
  }
  .wovn-lang-selector {
    display: none !important;
  }
  .container {
    margin: 0 !important;
  }

  a[href]:after {
    content: "" !important;
  }
  abbr[title]:after {
    content: "" !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/AprilTag/AprilTagDownload.vue